import React from 'react';
import { Input, Button, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import FilterIcon from '../../../../assets/icons/filterIcon'; // Assuming you use this for the search icon

interface FilterActionsProps {
  searchPlaceholder?: string;
  addFilterText?: string;
  showReportText?: string;
  addButtonText?: string;
  onAddFilter?: () => void;
  onShowReport?: () => void;
  onAdd?: () => void;
  showSearch?: boolean;
  showFilterButton?: boolean;
  showReportButton?: boolean;
  showAddButton?: boolean;
  leadModalVisible?: boolean;
  onSearch?: (value: string) => void;
  handleAddFilterClick?: () => void;
  handleAddClick?: () => void;
}

const FilterActions: React.FC<FilterActionsProps> = ({
                                                       searchPlaceholder,
                                                       addFilterText,
                                                       showReportText,
                                                       addButtonText,
                                                       onAddFilter,
                                                       onShowReport,
                                                       onAdd,
                                                       showSearch = true,
                                                       showFilterButton = true,
                                                       showAddButton = true,
                                                       showReportButton,
                                                       leadModalVisible,
                                                       onSearch,
                                                       handleAddFilterClick,
                                                       handleAddClick,
                                                     }) => {
  return (

    <div className="flex justify-between bg-white w-full p-2">
      <div className="flex grow">
        {showSearch && (
          <Input
            className="max-w-[500px]  h-[40px] border border-[#DBD7D7] hover:!border-[#DBD7D7] focus:!border-[#DBD7D7] shadow-none"
            placeholder={searchPlaceholder || "Search via agent, id, cnic, email"}
            prefix={<SearchOutlined />}
            onChange={e => onSearch && onSearch(e.target.value)}
          />
        )}

        {showFilterButton && (
          <Button
            type="link"
            className="text-blue-500 flex items-center"
            icon={<FilterIcon />}
            onClick={handleAddFilterClick}
          >
            Add Filter
          </Button>
        )}
      </div>
      <div className="flex flex-row gap-2">
        <div >
          {showReportButton && (
            <Button
              className=" !border-[#BD273B] text-[#BD273B]  hover:!border-[#BD273B] px-5 rounded-lg w-[135px] h-[40px] flex items-center justify-center"
              onClick={onShowReport}
            >
              {showReportText}
            </Button>
          )}
        </div>
        <div className="">
          {showAddButton && (
            <Button
              className="bg-[#BD273B] text-white hover:!text-white hover:!border-[#BD273B] px-5 rounded-lg w-[135px] h-[40px] flex items-center justify-center"
              onClick={handleAddClick}
            >
              {addButtonText}
            </Button>
          )}
        </div>
      </div>

    </div>

  );
};

export default FilterActions;
